import { JSX } from 'react';

export const mokVentsBack = {
	item: ({ x = -13, y = -1.625, opacity = 1 }: {x?: number; y?: number; opacity?: number;}): JSX.Element => {
		return <g fill="white" stroke="none" transform={`translate(${x}, ${y})`} opacity={opacity}>
			{/* Group 1 (0-5") */}
			<rect x="0" y="1.125" width="5" height="0.25" rx="0.125" ry="0.125"/>
			<rect x="0" y="1.875" width="5" height="0.25" rx="0.125" ry="0.125"/>
			{/* Group 2 (8-18") */}
			<rect x="8" y="1.125" width="10" height="0.25" rx="0.125" ry="0.125"/>
			<rect x="8" y="1.875" width="10" height="0.25" rx="0.125" ry="0.125"/>
			{/* Group 3 (21-26") */}
			<rect x="21" y="1.125" width="5" height="0.25" rx="0.125" ry="0.125"/>
			<rect x="21" y="1.875" width="5" height="0.25" rx="0.125" ry="0.125"/>
		</g>;
	},
	cutout: ({ x = -13, y = -1.625, opacity = 1 }: {x?: number; y?: number; opacity?: number;}): JSX.Element => {
		return <g fill="white" stroke="none" transform={`translate(${x}, ${y})`} opacity={opacity}>
			{/* Group 1 (0-5") */}
			<rect x="0" y="1.125" width="5" height="0.25" rx="0.125" ry="0.125"/>
			<rect x="0" y="1.875" width="5" height="0.25" rx="0.125" ry="0.125"/>
			{/* Group 2 (8-18") */}
			<rect x="8" y="1.125" width="10" height="0.25" rx="0.125" ry="0.125"/>
			<rect x="8" y="1.875" width="10" height="0.25" rx="0.125" ry="0.125"/>
			{/* Group 3 (21-26") */}
			<rect x="21" y="1.125" width="5" height="0.25" rx="0.125" ry="0.125"/>
			<rect x="21" y="1.875" width="5" height="0.25" rx="0.125" ry="0.125"/>
		</g>;
	}
};
